/** @file Weight of base track t's mirrorFix layer: the summed shares of the entries its links belong to. */
import type { AnimState } from '../../contracts/state';
import { fixTrackOf } from './fixTrackOf';
import { ownerShare } from './ownerShare';

/**
 * Σ ownerShare(link.owner) over the fix track's from-chain (a link without an owner counts 0): 1 while one
 * directional entry is the base's current entry and has finished mixing in; 0 when the track has no fix layer or
 * none of its owners shows. applyState layers the fix track at this alpha and crossfades its links by their shares.
 * Allocation-free.
 */
export function fixLayerWeight(state: AnimState, track: number): number {
  let weight = 0;
  for (let e = state.tracks[fixTrackOf(track)] ?? null; e !== null; e = e.from) {
    if (e.owner !== null) weight += ownerShare(state, track, e.owner);
  }
  return weight;
}
